module.exports = __webpack_public_path__ + "img/406.b7608bcf.jpg";